var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBesparing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1029",
    "data-name": "Groupe 1029",
    transform: "translate(0.179)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-0.179)",
    fill: "#d4eacd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_97",
    "data-name": "Soustraction 97",
    d: "M14.638,15H2.361a.471.471,0,0,1-.472-.469V7.938l-.469.38a.475.475,0,0,1-.667-.035l-.632-.7a.468.468,0,0,1,.036-.662l2.87-2.515L7.711.3A1.177,1.177,0,0,1,8.5,0a1.19,1.19,0,0,1,.791.3l2.988,2.619V1.406a.471.471,0,0,1,.472-.469h1.889a.471.471,0,0,1,.472.469v4l1.732,1.518a.466.466,0,0,1,.036.662l-.631.7a.475.475,0,0,1-.667.036l-.47-.325v6.539A.471.471,0,0,1,14.638,15ZM7.462,8.762h0L4.495,11.713l.565.561,2.4-2.387,1.6,1.592,2.523-2.5.917.91V7.5H10.1l.917.91L9.064,10.352l-1.6-1.59Z",
    transform: "translate(6.5 7)",
    fill: "#43b02a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBesparing);
export default __webpack_public_path__ + "static/media/besparing.3c22575a6117afdde543767d031faf8e.svg";
export { ForwardRef as ReactComponent };